import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Play, Users, Globe, TrendingUp } from "lucide-react";
import dashboardImage from "@/assets/demo-dashboard-new-optimized.png";
import renestLogo from "@/assets/renest-logo-transparent.png";
const HeroSection = () => {
  return <section className="pt-16 sm:pt-20 pb-24 sm:pb-32 px-4 bg-gradient-to-br from-background via-primary/5 to-background">
      <div className="container mx-auto">
        {/* Logo Renest */}
        <div className="flex justify-center mb-8 sm:mb-12">
          <img src={renestLogo} alt="Renest Logo" className="h-16 sm:h-24 w-auto" width="192" height="192" />
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Content */}
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-4 sm:space-y-6">
              <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium">
                <TrendingUp className="h-3 sm:h-4 w-3 sm:w-4" />
                Télétravail à l'international simplifié
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Avec Renest, transformez le temps de vos{" "}
                <span className="text-primary">équipes en avantages</span>
              </h1>
              
              <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-lg">
                Offrez à vos équipes le monde comme bureau : leurs points financent l'expérience, 
                nous gérons le reste.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-8 py-6 sm:flex sm:items-center">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-primary">50+</div>
                <div className="text-xs sm:text-sm text-muted-foreground">Destinations</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-border"></div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-primary">500+</div>
                <div className="text-xs sm:text-sm text-muted-foreground">Entreprises</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-border"></div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-primary">98%</div>
                <div className="text-xs sm:text-sm text-muted-foreground">Satisfaction</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 shadow-lg group w-full sm:w-auto" asChild>
                <Link to="/company-registration">
                  Démarrer gratuitement
                  <ArrowRight className="ml-2 h-4 sm:h-5 w-4 sm:w-5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
              
              <Button variant="outline" size="lg" className="text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 group w-full sm:w-auto" asChild>
                <Link to="/auth">
                  <Play className="mr-2 h-4 sm:h-5 w-4 sm:w-5" />
                  Voir la démo
                </Link>
              </Button>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6 pt-6">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Users className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Gestion d'équipe 100% flexible</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Globe className="h-4 w-4 text-blue-500 flex-shrink-0" />
                <span>Configuration en 5 minutes</span>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative z-10 bg-white rounded-2xl shadow-2xl border overflow-hidden">
              <img src={dashboardImage} alt="RENEST Dashboard" className="w-full h-auto" width="1188" height="784" />
            </div>
            
            {/* Background decorations */}
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-primary/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-primary/5 rounded-full blur-3xl"></div>
            
            {/* Floating elements */}
            <div className="hidden sm:block absolute -top-6 -left-6 bg-white rounded-xl shadow-lg p-4 animate-fade-in z-20">
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-medium">10 collaborateurs actifs</span>
              </div>
            </div>
            
            <div className="hidden sm:block absolute -bottom-6 -right-6 bg-white rounded-xl shadow-lg p-4 animate-fade-in z-20" style={{
            animationDelay: "0.5s"
          }}>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Globe className="h-4 w-4 text-primary" />
                </div>
                <div>
                  <div className="text-sm font-medium">Nouvelle destination</div>
                  <div className="text-xs text-muted-foreground">Lisbonne, Portugal</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;